import React from "react";

// Minimal, abstract bridge silhouette — a single spanning arch with vertical cables.
export function BridgeMotif({ className = "", stroke = "#E08A2B", animate = false, width = 320, height = 90 }) {
  return (
    <svg
      viewBox="0 0 320 90"
      width={width}
      height={height}
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M4 74 Q160 -6 316 74"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        className={animate ? "bridge-path" : ""}
      />
      <line x1="4" y1="74" x2="316" y2="74" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" opacity="0.55" />
      {[40, 80, 120, 160, 200, 240, 280].map((x) => {
        const t = (x - 4) / 312;
        const y = 74 - 80 * (t * (1 - t)) * 4 * 0.98;
        return <line key={x} x1={x} y1={y} x2={x} y2="74" stroke={stroke} strokeWidth="1" opacity="0.4" />;
      })}
    </svg>
  );
}

// ConQuién Hoy mark — two overlapping conversation bubbles (navy + gold) with dots.
export function BridgeMark({ size = 30, navy = "#16294D", gold = "#E08A2B" }) {
  return (
    <svg viewBox="0 0 40 34" width={size} height={size * 0.85} fill="none" aria-hidden="true">
      {/* back bubble (gold) */}
      <path d="M14 4 h20 a5 5 0 0 1 5 5 v9 a5 5 0 0 1 -5 5 h-8 l-6 5 v-5 h-1 a5 5 0 0 1 -5 -5 v-9 a5 5 0 0 1 5 -5 z" fill={gold} />
      {/* front bubble (navy) */}
      <path d="M6 11 h16 a5 5 0 0 1 5 5 v8 a5 5 0 0 1 -5 5 h-7 l-6 5 v-5 h-3 a5 5 0 0 1 -5 -5 v-8 a5 5 0 0 1 5 -5 z" fill={navy} />
      {/* dots inside navy bubble */}
      <circle cx="10.5" cy="20" r="1.6" fill="#FFFFFF" />
      <circle cx="16" cy="20" r="1.6" fill="#FFFFFF" />
      <circle cx="21.5" cy="20" r="1.6" fill="#FFFFFF" />
    </svg>
  );
}

// Wordmark: "ConQuién" (navy) + "Hoy" (gold). variant: "stacked" | "inline"
export function BrandWordmark({ className = "", variant = "inline" }) {
  if (variant === "stacked") {
    return (
      <span className={`font-display font-extrabold leading-none tracking-tight ${className}`}>
        <span className="block text-navy">ConQuién</span>
        <span className="block text-terracotta">HOY</span>
      </span>
    );
  }
  return (
    <span className={`font-display font-extrabold tracking-tight ${className}`}>
      <span className="text-navy">ConQuién</span> <span className="text-terracotta">HOY</span>
    </span>
  );
}
